// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container .must[data-v-0e2a2ed4] {\n  color: #ff1818;\n}", ""]);
// Exports
module.exports = exports;
